export default __webpack_public_path__ + "static/media/Zoo_05.13a82422.png";